<template>
  <div
    class="m-3 py-3 pl-3 rounded-md bg-white lightshadow"
    @click="goBrandPlace"
  >
    <div class="flex flex-row">
      <VImage
        class="flex-shrink-0 mr-3 my-auto"
        radius="6"
        width="44"
        height="44"
        :src="brandLogo"
      />
      <div class="mr-3 w-full overflow-x-hidden">
        <div class="flex flex-row justify-between flex-no-wrap">
          <div class="text-left flex text-xs">
            <span class="my-auto"
              ><div
                v-show="state === 'IN_PROGRESS'"
                style="
                  width: 36px;
                  height: 20px;
                  line-height: 20px;
                  background: linear-gradient(135deg, #acf700 0%, #6edf0f 100%);
                  border-radius: 5px;
                "
                class="text-xs inline-block text-center mr-1"
              >
                上新
              </div>
              <div
                v-show="state === 'WARMING_UP'"
                style="
                  width: 36px;
                  height: 20px;
                  line-height: 20px;
                  background: linear-gradient(315deg, #ffb1b1 0%, #f70000 100%);
                  border-radius: 5px;
                "
                class="text-xs inline-block text-center mr-1 text-white"
              >
                预告
              </div></span
            >
            <span class="my-auto font-semibold">{{ brandName }}</span>
          </div>
          <div
            v-distributor="true"
            class="
              inline-block
              bg-red
              text-white
              rounded-full
              py-1
              px-2
              text-xs text-center
            "
            style="width: 6rem; max-height: 29px"
            @click.stop="showDiag"
          >
            分享赚钱&nbsp;<img
              class="inline"
              style="height: 1rem"
              src="@/assets/home/fenxiangzhuanqian.svg"
              alt=""
            />
          </div>
          <div
            v-distributor="false"
            class="
              inline-block
              bg-red
              text-white
              rounded-full
              py-1
              px-2
              text-xs text-center
            "
            style="width: 6rem; max-height: 29px"
          >
            进入会场
          </div>
        </div>
        <div
          class="text-left mt-1 w-full overflow-x-auto"
          style="white-space: nowrap"
        >
          <span
            class="text-xxs text-red border-red1px rounded-md mr-1 px-1"
            style="padding-top: 0.1rem; padding-bottom: 0.1rem"
            >共{{ goodsList.length }}款</span
          >
          <span
            v-for="item in tags"
            :key="item.id"
            class="text-xxs text-red border-red1px rounded-md mr-1 px-1"
            style="padding-top: 0.1rem; padding-bottom: 0.1rem"
            >{{ item.name }}</span
          >
        </div>
      </div>
    </div>
    <div class="flex flex-row mt-2 overflow-x-scroll">
      <div v-for="(item, index) in goodsList" :key="index">
        <VImage
          class="flex-shrink-0 mr-3 my-auto"
          radius="6"
          width="110"
          height="110"
          :src="item.goodsImage"
        />
        <div
          class="flex flex-row mr-3 font-semibold items-baseline"
          :class="
            $store.state.user.distributionFlag
              ? 'justify-between'
              : 'justify-center'
          "
        >
          <span :class="$store.state.user.distributionFlag ? '' : 'text-red'">
            <template v-if="$store.state.user.distributionFlag">
              <span class="text-xs">￥</span>{{ item.actPrice }}
            </template>
            <template v-else>
              <span class="text-xs">￥</span>{{ Math.round((item.actPrice * 100 + item.distMarkup * 100)) / 100 }}
            </template>
          </span>
          <span
            v-distributor="true"
            class="text-red"
            style="white-space: nowrap"
            ><span class="text-xxs">省赚￥</span
            ><span class="text-xs">{{ item.saveProfit }}</span></span
          ><span
            v-distributor="false"
            class="ml-1 text-gray text-xxs font-normal line-through"
            >￥{{ item.linePrice }}</span
          >
        </div>
      </div>
    </div>
    <div>
      <Countdown :startTime="this.start" :endTime="this.end" :padding="0" />
    </div>
    <Overlay
      :show="diagVisible"
      @click.stop="
        () => {
          diagVisible = false;
          showShare = false;
        }
      "
    >
      <div
        v-show="!showShare"
        class="wrapper mx-12"
        :class="showInput ? 'my-6' : 'my-12'"
        @click.stop
      >
        <div class="bg-white rounded-lg mb-6 overflow-auto p-3 text-left">
          <div class="flex items-center mb-2">
            <div style="height: 46px; width: 46px" class="flex-shrink-0 mr-3">
              <img
                :src="forwardDetail.logoUrl"
                class="h-full w-full rounded"
                alt=""
              />
            </div>
            <div class="flex justify-between flex-grow">
              <div class="text-xs font-semibold">
                {{ forwardDetail.brandName }}
              </div>
              <div class="text-xs text-red font-semibold">
                {{ forwardDetail.goodsNum }}件商品
              </div>
            </div>
          </div>
          <div class="flex justify-center">
            <div style="height: 182px; width: 182px" class="mr-1">
              <img
                :src="forwardDetail.posterImg"
                class="h-full w-full rounded"
                alt=""
              />
            </div>
            <div class="flex flex-col justify-between">
              <img
                style="height: 89px; width: 89px"
                :src="forwardDetail.rightImgOne"
                alt=""
                class="rounded"
              />
              <img
                style="height: 89px; width: 89px"
                :src="forwardDetail.rightImgTwo"
                alt=""
                class="rounded"
              />
            </div>
          </div>
          <div class="flex justify-between mb-3 pt-1">
            <div class="text-red">
              <span class="text-xs"
                >品牌全场 ¥<span class="font-semibold mr-1 text-base">{{
                  forwardDetail.price
                }}</span
                >起</span
              >
              <div class="text-xxs font-semibold text-red">
                赚：{{ forwardDetail.saveProfit }}元起
              </div>
            </div>

            <div class="text-xs mt-1">
              {{
                dayjs(forwardDetail.activityTime).format("MM[月]DD[日] HH:mm")
              }}结束
            </div>
          </div>
          <!-- <div>
            <div class="text-xs">加价：</div>
            <div class="flex justify-between text-xs -mx-1 mb-2">
              <div
                style="background-color: #f1f1f1"
                class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                :class="{ activejiajia: jiajiaway === 1 }"
                @click="() => (jiajiaway = 1)"
              >
                不加价
              </div>
              <div
                style="background-color: #f1f1f1"
                class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                :class="{ activejiajia: jiajiaway === 2 }"
                @click="() => (jiajiaway = 2)"
              >
                加价10元
              </div>
              <div
                style="background-color: #f1f1f1"
                class="h-8 leading-8 mx-1 flex-grow text-center rounded"
                :class="{ activejiajia: jiajiaway === 3 }"
                @click="() => (jiajiaway = 3)"
              >
                加价20%
              </div>
            </div>
            <div>
              <Field
                class="rounded h-8 pt-1"
                :class="jiajiaway === 4 ? 'border-red-500 border' : ''"
                style="background-color: #f1f1f1"
                placeholder="自定义金额"
                input-align="center"
                readonly
                clickable
                :value="customjiajia"
                @touchstart.native.stop="
                  () => {
                    jiajiaway = 4;
                    showInput = true;
                  }
                "
              />
            </div>
          </div> -->

          <NumberKeyboard
            v-model="customjiajia"
            :show="showInput"
            theme="custom"
            extra-key="."
            close-button-text="完成"
            @blur="showInput = false"
          />
        </div>
        <Button
          style="height: 2rem"
          round
          color="linear-gradient(135deg, #E82237 0%, #FF9D9D 100%)"
          size="large"
          v-gapclick="generatePost"
          >生成海报</Button
        >
      </div>
    </Overlay>
  </div>
</template>

<script>
import {
  Image as VImage,
  Overlay,
  NumberKeyboard,
  Field,
  Toast,
  Button,
} from "vant";
import Countdown from "@/components/activity/Countdown";
import { priceMarkup, forwardDetail } from "@/api/forward.js";

export default {
  name: "BrandPlaceCard",
  components: {
    VImage,
    Countdown,
    Overlay,
    NumberKeyboard,
    // Field,
    Button,
  },
  props: [
    "goodsList",
    "id",
    "actId",
    "tags",
    "brandName",
    "brandLogo",
    "start",
    "end",
    "state",
    "signBrandId",
    "partId",
  ],
  data() {
    return {
      forwardDetail: {},
      diagVisible: false,
      showInput: false,
      customjiajia: "",
      jiajiaway: 1,
      urlAddress: null,
      showShare: false,

      browserType: localStorage.getItem("browserType"),
    };
  },
  methods: {
    goBrandPlace() {
      this.$router.push({
        name: "BrandPlace",
        params: { partId: this.id },
        query: {
          actId: this.actId,
          brandLogo: this.brandLogo,
          signBrandId: this.signBrandId,
        },
      });
    },
    showDiag() {
      this.$store.dispatch("app/showLoading");
      forwardDetail({
        actId: this.actId,
        partId: this.partId,
        partGoodsId: null,
        goodsId: null,
        suitId: null,
        customerId: null,
        retailId: null,
        forwardType: "BRAND",
      })
        .then(({ data }) => {
          this.$store.dispatch("app/hideLoading");
          this.forwardDetail = data;
          // this.diagVisible = true;
          this.generatePost();
        })
        .catch(() => this.$store.dispatch("app/hideLoading"));
    },
    generatePost() {
      let urlAddress;

      if (location.hostname === "localhost") {
        urlAddress =
          window.location.origin +
          "/brandPlace/" +
          this.partId +
          "?actId=" +
          this.actId +
          "&brandLogo=" +
          this.brandLogo +
          "&signBrandId=" +
          this.signBrandId +
          "&customerId=" +
          this.$store.state.user.forwardId;
      } else {
        urlAddress =
          location.origin +
          "/brandPlace/" +
          this.partId +
          "?actId=" +
          this.actId +
          "&brandLogo=" +
          this.brandLogo +
          "&signBrandId=" +
          this.signBrandId +
          "&customerId=" +
          this.$store.state.user.forwardId;
      }
      this.urlAddress = urlAddress;
      let params = {
        actId: this.actId,
        partId: this.partId,
        retailId: null,
        markupType: "NONE",
        markupAmount: 0,
        markupRatio: 0,
        forwardType: "BRAND",
        price: 0,
        urlAddress,
      };
      switch (this.jiajiaway) {
        case 1:
          params.markupType = "NONE";
          params.price = this.forwardDetail.price;
          break;
        case 2:
          params.markupType = "AMOUNT";
          params.markupAmount = 10;
          params.price = this.forwardDetail.price + 10;
          break;
        case 3:
          params.markupType = "RATIO";
          params.markupRatio = 0.2;
          params.price = this.forwardDetail.price * 1.2;
          break;
        case 4:
          if (!this.customjiajia) {
            return;
          }
          params.markupType = "AMOUNT";
          params.markupAmount = Number(this.customjiajia);
          params.price = this.forwardDetail.price + Number(this.customjiajia);
          break;
        default:
          break;
      }
      console.log(params);
      priceMarkup(params).then(({ data }) => {
        // this.showShare = true;
        this.diagVisible = false;
        this.$store.dispatch("sharePoster/show", {
          url: data.url,
          title: this.brandName,
          desc: "",
          link: urlAddress,
          imgUrl: this.brandLogo,
        });
      });
    },
  },
  computed: {
    time() {
      if (this.state === "IN_PROGRESS") {
        return (
          this.dayjs(this.end).diff(this.dayjs(new Date()), "seconds") * 1000
        );
      } else {
        return (
          this.dayjs(this.start).diff(this.dayjs(new Date()), "seconds") * 1000
        );
      }
    },
  },
};
</script>

<style>
</style>